<template>
  <div class="components__cnt-table_cause_groups">
    <table>
      <thead>
        <th>Anlässe</th>
        <th class="table-centered" colspan="2">(%)</th>
      </thead>
      <tbody>
        <tr>
          <td>
            <b>Akut</b>
            (Husten, Fieber, Haut/Nägel/Haare, Durchfall/Erbrachen, Schmerzen,
            Störungen/Erkrankungen in den Organsystemen, Unfall etc.)
          </td>
          <td>49,7</td>
          <td class="bracket-table_last" rowspan="2">
            <b>53,3</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Neue Morbidität</b>
          </td>
          <td>3,6</td>
        </tr>
        <tr>
          <td>
            <b>Prävention</b>
          </td>
          <td></td>
          <td class="bracket-table_last">
            <b>30,3</b>
          </td>
        </tr>
        <tr>
          <td>
            <b>Kontrollen</b>
            <table>
              <tr>
                <td>Akut</td>
                <td>8,4%</td>
              </tr>
              <tr>
                <td>Chronische Grunderkrankung</td>
                <td>1,8%</td>
              </tr>
            </table>
          </td>
          <td></td>
          <td class="bracket-table_last">
            <b>10,2</b>
          </td>
        </tr>
        <tr>
          <td>Zuweisungen</td>
          <td>0,1</td>
          <td class="bracket-table_last" rowspan="4">
            <b>6,2</b>
          </td>
        </tr>
        <tr>
          <td>Sonstige</td>
          <td>0,4</td>
        </tr>
        <tr>
          <td>Ohne Arztkontakt</td>
          <td>2,9</td>
        </tr>
        <tr>
          <td>Therapie</td>
          <td>2,8</td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <td class="table-caption" colspan="3">
            <b>Tab. 1</b>
            Gruppe der Vorstellungsanlässe
          </td>
        </tr>
      </tfoot>
    </table>
  </div>
</template>

<style lang="scss" scoped>
.components__cnt-table_cause_groups {
  @import "~stylesheets/frontend/specific/content-widgets_tables";
}
</style>
